import { useAddress, useContract } from '@thirdweb-dev/react';
import { useAsync } from 'react-use';
import { bigNumberToDecimal, bigNumberToDecimalV2 } from '@app/helpers/format';
import { useConfig } from '@app/config';

export function useEpochDetails() {
  const address = useAddress();
  const config = useConfig();
  const { contract } = useContract(config?.CONTRACTS.DIVIDENDS);

  const { value, loading } = useAsync(async () => {
    if (!contract || !address) {
      return;
    }

    const nextCycleStartTime = await contract.call('nextCycleStartTime');

    const cycleDuration = await contract.call('cycleDurationSeconds');

    const distributedTokensLength = await contract.call(
      'distributedTokensLength'
    );

    const distributedTokensIndexes = new Array(+distributedTokensLength)
      .fill(0)
      .map((_, index) => index);

    const distributedTokens = await Promise.all(
      distributedTokensIndexes.map(async index => {
        const distributedToken = await contract.call('distributedToken', [
          index
        ]);

        const info = await contract.call('dividendsInfo', [distributedToken]);

        return {
          address: distributedToken,
          pendingAmount: bigNumberToDecimalV2(info[2], 18)
        };
      })
    );

    return {
      nextCycleStartTime,
      cycleDuration,
      distributedTokensIndexes,
      distributedTokens: distributedTokens.filter(item => !!item?.address)
    };
  }, [contract, address]);

  return {
    isLoading: loading,
    nextCycleStartTime: value?.nextCycleStartTime,
    cycleDuration: value?.cycleDuration,
    distributedTokensIndexes: value?.distributedTokensIndexes,
    distributedTokens: value?.distributedTokens
  };
}
